import React, { FC } from 'react'
import { QuestionProps } from '../types'
import { BaseTrainedQuestion } from './base-trained-question'

export const DatasetQuestion: FC<QuestionProps> = props => {
  return (
    <BaseTrainedQuestion {...props} questionLabel="Generated Task" answerLabel="Generated Query" layout="vertical" />
  )
}
